/** PURE_IMPORTS_START .._.._Observable,.._.._operator_finally PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { _finally } from '../../operator/finally';
Observable.prototype.finally = _finally;
Observable.prototype._finally = _finally;
//# sourceMappingURL=finally.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/finally.js
// module id = ./node_modules/rxjs/_esm5/add/operator/finally.js
// module chunks = vendor